<template>
  <section class="card" :class="classes">
    <header class="card-header d-flex justify-content-between" role="tab" :id="headingId">
      <div>
        <h4 class="card-title m-0"><slot name="heading-title"><i :class="fontIcon" aria-hidden="true"></i> {{ title }}</slot></h4>
        <div  class="small text-muted"><slot name="heading-detail"></slot></div>
      </div>

      <div class="">
        <slot name="heading-right"></slot>
      </div>
    </header>

    <div :id="id" class="collapse" :class="{show : active}" role="tabpanel" :aria-labelledby="headingId">
      <div class="card-body">
        <slot></slot>
      </div>
    </div>

    <div v-if="$slots.footer" class="card-footer">
      <slot name="footer"></slot>
    </div>

  </section>
</template>

<script>
  export default {
    props: {
      title: String,
      fontIcon: String,
      id: String,
      active: Boolean,
      styling: String
    },

    computed: {
      classes() {
        if(!this.styling) {
          return null;
        }

        return `card-${this.styling}`;
      },

      headingId() {
        return this.id + '-heading';
      },
    }
  }
</script>